// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'

import config from 'SrcConfig'

import Api from './plugins/api'
import BootstrapVue from 'bootstrap-vue'
import Config from './plugins/config'
import Dir from './plugins/dir'
import Messages from './plugins/messages'
import Meta from 'vue-meta'
import NumericInput from './plugins/numeric-input'
import RequiredMenu from './plugins/required-symbol'
import PortalVue from 'portal-vue'
import Snotify from 'vue-snotify'
import VeeValidate from 'vee-validate'
import VueCookies from 'vue-cookies'
import VueI18n from 'vue-i18n'

Vue.use(Api)
Vue.use(BootstrapVue)
Vue.use(Config)
Vue.use(Dir)
Vue.use(Messages)
Vue.use(Meta)
Vue.use(NumericInput)
Vue.use(RequiredMenu)
Vue.use(PortalVue)
Vue.use(Snotify)
Vue.use(VeeValidate, { fieldsBagName: 'veeFields' })
Vue.use(VueCookies)
Vue.use(VueI18n)

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas as solid } from '@fortawesome/free-solid-svg-icons'

import store from './store'
import router from './router'
import * as types from './store/types'
import { guard as authGuard } from './auth'

library.add(solid)
Vue.component('font-awesome-icon', FontAwesomeIcon)

/* eslint-disable no-new */

import i18nMessages from './i18n'
const i18n = new VueI18n({
  locale: config.locale,
  fallbackLocale: 'en',
  messages: i18nMessages
})

import App from './App'

new Vue({
  el: '#app',
  store,
  router,
  i18n,
  template: '<App/>',
  components: {
    App
  },
  beforeCreate () {
    let locale = this.$cookies.get(types.LOCALE_COOKIE) || config.locale
    this.$store.commit(types.SET_LOCALE, {
      value: locale,
      validator: this.$validator,
      i18n: this.$i18n,
      cookies: this.$cookies
    })
  }
})

router.beforeEach((to, from, next) => {
  authGuard(to.path, to.meta && to.meta.auth, next)
})
